import { Typography } from "@mui/material";
import React, { useEffect } from "react";

import { Container } from "@mui/system";
import styles from "./Support.module.css";
import Grid from "@mui/material/Grid";
import phone_icon from "assets/images/phone-icon.svg";
import email_icon from "assets/images/email-icon.svg";
import TextField from "component/textField/TextField";
import { useForm } from "react-hook-form";
import LabeledTextarea from "component/textArea/LabeledTextarea";
// import LabeledSelect from "components/select/labeledSelect";
import AppButton from "component/button/AppButton";
import { yupResolver } from "@hookform/resolvers/yup";
import { contactUsSchema } from "schemas/contactUs/ContactUs";
// import { useGetApplications } from "api/queries/dashboard/applications/Applications";
import { useContactUs } from "api/mutations/support/support";
import AppBackdrop from "component/appBackdrop/AppBackdrop";
import Feedback from "component/feedback/Feedback";
import customer_care_icon from "assets/images/call centre icon.png";
import LabeledSelect from "component/select/labeledSelect/LabeledSelect";
import PhoneNumberInput from "component/phoneNumberInput/PhoneNumberInput";
function Support({ type, applications }) {
  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
    watch,
    reset,
    trigger,
  } = useForm({
    resolver: yupResolver(contactUsSchema),
  });

  const { supportFeedback, setSupportFeedback, mutate, isLoading } =
    useContactUs();
  const phone = watch("phone", "");

  useEffect(() => {
    if (phone) {
      trigger("phone");
    }
  }, [phone]);

  useEffect(()=>{
    setValue('type', type)
  }, [])

  const onSubmit = (data) => {
    mutate(data);
  };
  return (
    <div className={styles.support}>
      <Container maxWidth="lg">
        <div className={styles.support_content}>
          <Container maxWidth="lg">
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <div className={styles.contact_us}>
                  <div className={styles.heading}>
                    <Typography variant="h6">Contact Us</Typography>
                    <Typography>
                      Fill up the form and our Team will get back to you within
                      24 hours.
                    </Typography>
                  </div>
                  <div className={styles.icon}>
                    <img src={customer_care_icon} alt="" />
                  </div>
                  <div className={styles.content}>
                    <a href="tel:+234 700 909 909 909">
                      <img src={phone_icon} alt="" />
                      0700 909 909 909
                    </a>
                    <a href="tel:+234 700 909 909 909">
                      <img src={phone_icon} alt="" /> +234 700 909 909 909
                    </a>

                    <a href="mailto:customercarenigeria@stanbicibtc.com">
                      <img src={email_icon} alt="" />
                      customercarenigeria@stanbicibtc.com
                    </a>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className={styles.contact_us_form}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        textValidation={true}
                        setValue={setValue}
                        watch={watch}
                        required={true}
                        type="text"
                        placeholder="First Name"
                        label="First Name"
                        register={register}
                        errors={errors}
                        name="firstname"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        textValidation={true}
                        setValue={setValue}
                        watch={watch}
                        type="text"
                        required={true}
                        placeholder="Last Name"
                        label="Last Name"
                        register={register}
                        errors={errors}
                        name="lastname"
                      />
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <TextField
                        type="text"
                        required={true}
                        placeholder=""
                        label="Email"
                        register={register}
                        errors={errors}
                        name="email"
                      />
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <div className={styles.field}>
                        {" "}
                        <PhoneNumberInput
                          setValue={setValue}
                          name="phone"
                          value={phone}
                          errors={errors}
                        />
                      </div>
                    </Grid>

                    {type === "in-app" && (
                      <Grid item xs={12} md={12}>
                        <LabeledSelect
                          required={true}
                          data={applications?.data?.data.map((item) => {
                            return {
                              label: item.applicationId,
                              value: item.applicationId,
                            };
                          })}
                          register={register}
                          errors={errors}
                          name="applicationID"
                          label="Application ID"
                          placeholder="Select Application ID"
                        />
                      </Grid>
                    )}
                    <Grid item xs={12} md={12}>
                      <LabeledTextarea
                        label="Message"
                        placeholder={"Message"}
                        register={register}
                        errors={errors}
                        name="message"
                        required={true}
                      />
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <div className={styles.btn}>
                        <AppButton
                          loading={isLoading}
                          width={"180px"}
                          handleAction={handleSubmit(onSubmit)}
                          textColor="#FFFFFF"
                          btnBg="#0072CE"
                          btnText="Submit"
                        />
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            </Grid>
          </Container>
        </div>
      </Container>
      {supportFeedback.open && (
        <AppBackdrop
          openModal={supportFeedback.open}
          handleCloseModal={() => {
            setSupportFeedback({});
          }}
          children={
            <Feedback
              btnText={"Close"}
              secondaryText={supportFeedback.message}
              feedbackState={supportFeedback.status}
              handleClickBtn={() => {
                reset({
                  firstname: "",
                  lastname: "",
                  message: "",
                  applicationID: "",
                });
                setSupportFeedback({});
              }}
            />
          }
        />
      )}
    </div>
  );
}

export default Support;
